(function () {
  'use strict';

  var overlay = document.querySelector('[data-focal-search-overlay]');
  var drawer = document.querySelector('[data-focal-search-drawer]');
  if (!drawer) return;

  var input = drawer.querySelector('[data-focal-search-input]');
  var quicklinks = drawer.querySelector('[data-focal-search-quicklinks]');
  var results = drawer.querySelector('[data-focal-search-results]');
  var empty = drawer.querySelector('[data-focal-search-empty]');
  var viewAllLink = drawer.querySelector('[data-focal-search-view-all]');
  var tabs = drawer.querySelectorAll('[data-focal-search-tab]');
  var panels = {
    products: drawer.querySelector('[data-focal-search-panel="products"]'),
    articles: drawer.querySelector('[data-focal-search-panel="articles"]'),
    collections: drawer.querySelector('[data-focal-search-panel="collections"]')
  };

  var debounceTimer = null;
  var currentQuery = '';

  function open() {
    overlay.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      overlay.classList.add('is-visible');
      drawer.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
    setTimeout(function () { input && input.focus(); }, 300);
  }

  function close() {
    overlay.classList.remove('is-visible');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () { overlay.hidden = true; }, 400);
  }

  document.addEventListener('focal:search-open', open);
  drawer.querySelectorAll('[data-focal-search-close]').forEach(function (b) { b.addEventListener('click', close); });
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format((cents || 0) / 100);
    } catch (e) {
      return '$' + ((cents || 0) / 100).toFixed(2);
    }
  }

  function renderProducts(products) {
    if (!products.length) { panels.products.innerHTML = '<p class="focal-search-drawer__empty">No products found.</p>'; return; }
    panels.products.innerHTML = products.map(function (p) {
      var price = formatMoney(p.price);
      var compare = p.compare_at_price && p.compare_at_price > p.price ? '<span class="focal-price--compare">' + formatMoney(p.compare_at_price) + '</span>' : '';
      var img = p.image ? '<img class="focal-search-result-item__image" src="' + p.image + '" alt="' + (p.title || '') + '" loading="lazy">' : '<span class="focal-search-result-item__image"></span>';
      return '<a class="focal-search-result-item" href="' + p.url + '">' +
        img +
        '<span>' +
          '<span class="focal-search-result-item__title">' + p.title + '</span>' +
          '<span class="focal-search-result-item__price"><span class="focal-price--sale">' + price + '</span>' + compare + '</span>' +
        '</span>' +
      '</a>';
    }).join('');
  }

  function renderSimpleList(container, items, emptyText) {
    if (!items.length) { container.innerHTML = '<p class="focal-search-drawer__empty">' + emptyText + '</p>'; return; }
    container.innerHTML = items.map(function (item) {
      return '<a class="focal-search-result-item" href="' + item.url + '">' +
        '<span><span class="focal-search-result-item__title">' + item.title + '</span></span>' +
      '</a>';
    }).join('');
  }

  function switchTab(name) {
    tabs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-focal-search-tab') === name); });
    Object.keys(panels).forEach(function (key) {
      panels[key].hidden = key !== name;
      panels[key].classList.toggle('is-active', key === name);
    });
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () { switchTab(tab.getAttribute('data-focal-search-tab')); });
  });

  function runSearch(query) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product,collection,article' +
      '&resources[limit]=4' +
      '&resources[options][unavailable_products]=last';

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (query !== currentQuery) return;
        var res = (data && data.resources && data.resources.results) || {};
        var products = res.products || [];
        var articles = res.articles || [];
        var collections = res.collections || [];

        if (!products.length && !articles.length && !collections.length) {
          results.hidden = true;
          empty.hidden = false;
          return;
        }

        empty.hidden = true;
        results.hidden = false;
        renderProducts(products);
        renderSimpleList(panels.articles, articles, 'No journal posts found.');
        renderSimpleList(panels.collections, collections, 'No collections found.');
        switchTab('products');
        if (viewAllLink) viewAllLink.href = '/search?q=' + encodeURIComponent(query) + '&type=product';
      })
      .catch(function () { /* fail silently */ });
  }

  if (input) {
    input.addEventListener('input', function () {
      var query = input.value.trim();
      currentQuery = query;
      clearTimeout(debounceTimer);

      if (query.length < 2) {
        quicklinks.hidden = false;
        results.hidden = true;
        empty.hidden = true;
        return;
      }

      quicklinks.hidden = true;
      debounceTimer = setTimeout(function () { runSearch(query); }, 300);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        window.location.href = '/search?q=' + encodeURIComponent(input.value.trim()) + '&type=product';
      }
    });
  }
})();